import { useState } from "react"
import Switch, { ReactSwitchProps } from "react-switch"

import { IconContainer, SwitchContainer } from "@/components/Switch"
import { ThemeName, useCurrentTheme, useTheme } from "@/theme"
import { withSubscribe } from "@/utils/withSubscribe"

import { DarkThemeIcon, LightThemeIcon } from "../../../components/icons"

type ThemeSwitcherProps = Partial<ReactSwitchProps>

export const ThemeSwitcher = withSubscribe((props: ThemeSwitcherProps) => {
  const theme = useCurrentTheme()
  const [hover, setHover] = useState<boolean>(false)
  const { themeName, toggleTheme } = useTheme()
  const isDarkTheme = themeName === ThemeName.Dark
  const isTouchDevice = "ontouchstart" in document.documentElement
  const Icon = isDarkTheme ? DarkThemeIcon : LightThemeIcon

  const handleTouchThemeSwitch = () => {
    setHover(true)
    setTimeout(() => {
      toggleTheme()
    }, 400)
    setTimeout(() => {
      setHover(false)
    }, 1200)
  }

  const eventHandlers = {
    ...(!isTouchDevice && { onMouseEnter: () => setHover(true) }),
    ...(!isTouchDevice && { onMouseLeave: () => setHover(false) }),
    ...(isTouchDevice && { onTouchStart: handleTouchThemeSwitch }),
  }

  const handleChange = () => {
    !isTouchDevice && toggleTheme()
  }

  return (
    <SwitchContainer {...eventHandlers}>
      {hover ? (
        <Switch
          onChange={handleChange}
          checked={isDarkTheme}
          checkedIcon={<IconContainer>{<DarkThemeIcon />}</IconContainer>}
          uncheckedIcon={<IconContainer>{<LightThemeIcon />}</IconContainer>}
          handleDiameter={15}
          offColor={theme.color["Colors/Background/bg-secondary"]}
          offHandleColor={theme.color["Colors/Background/bg-brand-primary"]}
          onColor={theme.color["Colors/Background/bg-secondary"]}
          onHandleColor={theme.color["Colors/Background/bg-brand-primary"]}
          {...props}
        />
      ) : (
        <IconContainer>{<Icon />}</IconContainer>
      )}
    </SwitchContainer>
  )
})
